import React, { useEffect } from "react";
import { msg } from "../../text/form-message.text";
import { href } from "../../utils/ui-urls";
import { title } from "../../text/page-title.text";
import { formTitle } from "../../text/form-title.text";
import { button } from "../../text/button.text";
import { Button, Title } from "@creditonebank/c1b-components";

const AccountNotActive = () => {
  useEffect(() => {
    document.title = title.accountNotActive;
    window.scrollTo(0, 0);
  }, []);

  const handleResendActivation = () => {
    window.location.href = href.resendActivationMail;
  };

  return (
    <div className="bg">
      <div className="form-element-username-success">
        <Title tag="h2">
          {formTitle.accountNotActive}
        </Title>
        <div className="description">
          <p className="desc2">{msg.accountNotActive}</p>
        </div>
        <Button
          onClick={handleResendActivation}
          size="medium"
          className="button-style-success"
        >
          {button.accountNotActive}
        </Button>
      </div>
    </div>
  );
};

export default AccountNotActive;
